export default "__VITE_ASSET__DdK8zvqz__"